const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class ColdWar extends Event {
    constructor(){
        super(
            Age.Age2,
            EventNames.ColdWar,
            "The two strongest civilizations score 6 science.",
            {}
        )
    }
}

module.exports = ColdWar;